import React, { useCallback } from 'react'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_CHANNELS_AUTHENTICATE } from 'ducks/drawers/types'
import { buildDrawerQueryParam } from 'ducks/drawers/util'
import NoticeBar from 'components/NoticeBar'

import styles from './styles.less'

export default function MessengerDisconnected({ isManager, widget }) {
  const { drawerId, openDrawer: openAddDrawer } = useDrawer({
    type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
    closeIgnoresStack: true,
  })

  const { id: currentChannelId, name } = widget

  const onOpen = useCallback(
    () => {
      openAddDrawer(currentChannelId, {
        query: {
          ...buildDrawerQueryParam(drawerId, 'drawerChannelType', 'messenger'),
          ...buildDrawerQueryParam(drawerId, 'drawerSource', 'messenger'),
        },
      })
    },
    [openAddDrawer, currentChannelId, drawerId]
  )

  let callToActionContent =
    'Please contact your administrator to reconnect your Facebook Page now.'
  if (isManager) {
    callToActionContent = (
      <a className={styles.demoBarLinkInlineWarning} onClick={onOpen}>
        Please reconnect the channel now.
      </a>
    )
  }

  return (
    <NoticeBar
      flagName={`app-notice-fb-widget-disconnected-${currentChannelId}`}
      dismissible
      type="warning"
    >
      Oh no, looks like the Facebook Page has been disconnected from the channel{' '}
      {name}!&nbsp;
      {callToActionContent}
    </NoticeBar>
  )
}
